/**
 * CSV garage import for Motrio and Renault.
 * Set featureFlags.GARAGE_CSV_IMPORT_ENABLED to force it on or off.
 * With no flag, it stays on outside production.
 */
export function isGarageCsvImportEnabled(appConfig) {
  const segmentGroup = appConfig.segmentGroup;
  if (segmentGroup !== 'MOTRIO' && segmentGroup !== 'RENAULT') return false;

  const flag = appConfig.featureFlags && appConfig.featureFlags.GARAGE_CSV_IMPORT_ENABLED;
  if (typeof flag === 'boolean') return flag;
  return appConfig.env !== 'production';
}
